import { createApi } from "@reduxjs/toolkit/query/react";
import { v4 as uuidv4 } from "uuid";
import { supabaseBaseQuery, supabase } from "../../../supabase";

interface UploadFileResult {
  id: string;
  path: string;
  fullPath: string;
  fileName: string;
}

const filesApi = createApi({
  reducerPath: "api.Files",
  baseQuery: supabaseBaseQuery,
  endpoints: (build) => ({
    uploadFile: build.mutation<UploadFileResult, { file: File }>({
      queryFn: async ({ file }) => {
        const fileName = `${uuidv4()}-${file.name}`;

        const { data: uploadData, error: uploadError } = await supabase.storage
          .from("resource-assets")
          .upload(fileName, file, {
            cacheControl: "3600",
            upsert: false,
          });

        if (uploadError) {
          return {
            error: {
              status: 400,
              data: uploadError.message,
            },
          };
        }

        return {
          data: {
            id: uploadData.id,
            path: uploadData.path,
            fullPath: uploadData.fullPath,
            fileName,
          },
        };
      },
    }),
  }),
});

const { useUploadFileMutation } = filesApi;

export { filesApi, useUploadFileMutation };
